import type { FreelancerAddDiplomasDocumentPageLocales } from '../types';

const freelancerAddDiplomasDocumentPageLocales: FreelancerAddDiplomasDocumentPageLocales =
  {
    diplomaAdded: 'Diploma uploaded successfully!',
    fileRequired: 'Upload a proof to save diploma.',
    helperMessage:
      'Select the diploma you want to add below. You can then upload the diploma.',
    noDataMessage:
      'Something went wrong! The necessary resources for this page are not available.',
    saveDiploma: 'Save diploma',
    selectDiploma: 'Select diploma',
    selectDocType: 'No diploma type selected.',
    title: 'Add diploma',
    uploadProof: 'Upload proof (pdf)',
    wrongFileExtension:
      'Document does not have the correct extension. Upload a PDF file or photo.',
  };

export default freelancerAddDiplomasDocumentPageLocales;
